"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.search = void 0;
exports.search = {
    search_title: "Список адресов",
    search_empty: "К сожалению, по заданным параметрам поиска пунктов сбора не найдено",
    search_filters: "Фильтры",
    search_resetFilters: "Сбросить фильтры",
};
//# sourceMappingURL=search.js.map